import { Component, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from 'src/services/auth.service';
import { Banner } from 'src/models/banner.model';
import { BannerService } from 'src/services/basic-services/banner.service';
import { BuildMode } from 'src/environments/environment.base';
import { ConfigState } from 'src/store/reducers/config.reducer';
import { NotificationService } from 'src/services/notification.service';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { UserInfoState } from 'src/store/reducers/user-info.reducer';
import { environment } from 'src/environments/environment';
import { filter } from 'rxjs/operators';
import { setUserRoles } from 'src/store/actions/config.action';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    // eslint-disable-next-line @angular-eslint/prefer-standalone
    standalone: false,
    host: {
        '[class.env-dev]': 'isDevelopment',
    },
})
export class AppComponent implements OnInit {
    public banner?: Banner;
    public notificationService = inject(NotificationService);
    public title = 'SESAMM TOOL 3';
    private authService = inject(AuthService);
    private bannerService = inject(BannerService);
    private currentUrl: string = '';
    private router = inject(Router);
    private store = inject<Store<{ userInfo: UserInfoState; config: ConfigState }>>(Store);

    /* eslint-disable @typescript-eslint/member-ordering */
    public isVisibleSidebar$: Observable<boolean> = this.store.select(
        (state) => state.config?.sidebarVisible ?? false
    );
    public userInfo$ = this.store.select((state) => state.userInfo);

    public get environmentLabel(): string {
        return 'DEVELOPMENT ENVIRONMENT';
    }

    public get isHome(): boolean {
        return this.currentUrl === '/' || this.currentUrl === '/home';
    }

    public get isDevelopment(): boolean {
        return environment.buildMode === BuildMode.DEVELOPMENT;
    }

    public ngOnInit(): void {
        this.userInfo$.subscribe((userInfo) => {
            if (userInfo) {
                this.bannerService.get().then((banner) => (this.banner = banner));
                this.authService.getUserStatus().subscribe({
                    next: (status) => {
                        const roles = status.internalClaims ?? [];
                        this.store.dispatch(setUserRoles({ roles }));
                    },
                    error: (error) => {
                        this.notificationService.handleError('Failed to get user status', error);
                    },
                });
            }
        });

        this.router.events
            .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
            .subscribe((e: NavigationEnd) => {
                this.currentUrl = e.urlAfterRedirects;
            });
    }
}
